import ItemView from "./ItemView";

export default class PuzzleItemView extends ItemView {
    
    constructor(target) {
        super(target);
    }

    destroy() {
        super.destroy();
        this.stopBlink();
    }

    set content(skin) {
        this.cache(false);
        super.content = skin;
        if (skin) {
            this.cache(true);
        }
    }
    
    hop() {
        createjs.Tween.get(this._target, { loop: 3 })
            .to({ y: this._yOrig - 50 }, 100, createjs.Ease.linear)
            .to({ y: this._yOrig }, 100, createjs.Ease.linear);
    }

    disappear() {
        this.stopBlink();
        const s = 1.2;
        createjs.Tween.get(this._target)
            .to({ y: this._yOrig - 50, scaleX: s, scaleY: s, alpha: 0 }, 300, createjs.Ease.linear);
    }

    scheduleBlink() {
        const delay = Math.random() * Blink.INTERVAL_MAX;
        this.blinkTween = createjs.Tween.get({}, { onComplete: _ => { this.scheduleBlink(); } })
            .wait(delay)
            .call(_ => {
                if (this._target.visible) {
                    this._blinking = true;
                    this.cache(false);
                    this._content.eyes.gotoAndStop("closed");
                }
            })
            .wait(Blink.DURATION)
            .call(_ => {
                if (this._blinking) {
                    this._blinking = false;
                    this._content.eyes.gotoAndStop("open");
                    this.cache(true);
                }
            })
            .wait(Blink.INTERVAL_MIN);
    }

    stopBlink() {
        if (this.blinkTween) {
            createjs.Tween.removeTweens(this.blinkTween.target);
            this._content.eyes.gotoAndStop("open");
            this.blinkTween = null;
            this._blinking = false;
        }
    }
};

const Blink = {
    INTERVAL_MIN: 2500,
    INTERVAL_MAX: 4500,
    DURATION: 300
}